import globals from "../../globals";
import { _sendWithAxios } from "../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

// MOTIVO OFERTA - LISTAR (igual loginService.js estilo: apenas repassa a promise)
export const listarMotivoOferta = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/listar`,
    "GET"
  );
};

// MOTIVO OFERTA - BUSCAR POR ID
export const buscarMotivoOfertaPorId = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/${id}`,
    "GET"
  );
};

// MOTIVO OFERTA - ADICIONAR
export const adicionarMotivoOferta = async (data) => {
  const payload = {
    descricao: data.descricao?.trim(),
    ativo: true,
    dataCriacao: new Date().toISOString(),
    dataAtualizacao: new Date().toISOString(),
  };
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/criar`,
    "POST",
    payload
  );
};

// MOTIVO OFERTA - ALTERAR
export const alterarMotivoOferta = async (data) => {
  const payload = {
    id: data.id,
    descricao: data.descricao?.trim(),
    ativo: data.ativo !== undefined ? data.ativo : true,
    dataCriacao: data.dataCriacao || new Date().toISOString(),
    dataAtualizacao: new Date().toISOString(),
  };
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/atualizar`,
    "PUT",
    payload
  );
};

// MOTIVO OFERTA - INATIVAR
export const inativarMotivoOferta = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/${id}/inativar`,
    "PUT"
  );
};

// MOTIVO OFERTA - ATIVAR
export const ativarMotivoOferta = async (id) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}MotivoOferta/${id}/ativar`,
    "PUT"
  );
};

// MOTIVO OFERTA - ATIVAR/INATIVAR (função auxiliar igual de antes, só repassa)
export const toggleMotivoOferta = async (id, ativo) => {
  if (ativo) {
    return await ativarMotivoOferta(id);
  } else {
    return await inativarMotivoOferta(id);
  }
};
